/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/143-key2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.658 4.91l-1.58-1.58-1.409-1.409-1.58-1.58c-.387-.387-1.077-.456-1.533-.152l-4.319 2.88a1.162 1.162 0 00-.383 1.444l1.101 2.203c.034.067.073.139.115.213L.499 12.5l-.5 3.5h3v-1h2v-2h2v-2h2V9.888c.1.06.196.113.284.157l2.203 1.101c.49.245 1.14.072 1.444-.383l2.88-4.319c.304-.456.236-1.146-.152-1.533zM2.354 13.354l-.707-.707 4.868-4.868.707.707-4.868 4.868zm11.974-6.733l-.707.707a.502.502 0 01-.707 0L8.671 3.085a.502.502 0 010-.707l.707-.707a.502.502 0 01.707 0l4.243 4.243a.502.502 0 010 .707z"/>'
  }
})
